module.exports = __webpack_public_path__ + "media/images/twitter-a912fe68896d9239fd9e42067b1491a9.svg";